module.exports = __webpack_public_path__ + "static/media/userGuide.63519e36.pdf";